import React from 'react';
import AppBar from 'material-ui/AppBar';

var divStyle = {
  backgroundColor: '#3f51b5',
};

export default class DrawerSimpleExample extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchShowing: 'hidden',
      AppBarShowing: 'visible',
      value:''
    };

    this.openSearch = this.openSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onKeySearch = this.onKeySearch.bind(this);
    this.openMinibus = this.openMinibus.bind(this);
    
  }

  handleToggle = () => this.setState({
    open: !this.state.open,
    searchShowing: 'hidden',
    AppBarShowing: 'visible',
  });
  handleClose = () => this.setState({
    open: false,
    searchShowing: 'hidden',
    AppBarShowing: 'visible',
    
  });

  openSearch(){
    this.setState({
        searchShowing:'visible',
        AppBarShowing: 'hidden',
    })
  }

  closeSearch(){
    this.setState({
        searchShowing:'hidden',
        AppBarShowing: 'visible',
    })
  }

  onKeySearch(event){
    if(event.key === 'Enter'){      
      alert('enter press here! ',this.state.value)
    }
  }

  onSearch(){
      alert('enter press here! ',this.state.value)
      console.log('....',this.state.value)
  }


  openMinibus(){
  

  }

  componentDidMount(){

    if(window.innerWidth < 1000 ){
      this.setState({
        searchShowing: 'hidden',
        AppBarShowing: 'visible',
      });
    }
  }

  render() {
      return (      
        <div >
         <AppBar 
            titleStyle={{ lineHeight: 'normal' }}
            title={
                    <div >
                      <div style={{ marginTop: 5, fontSize: 30}}>รถโพถ้อง</div>
                      <div style={{ fontSize: 'small'}}>คลิกที่รถเพื่อดูข้อมูลเพิ่มเติม</div>
                    </div>
                  }
            style={{backgroundColor:'#3f51b5'}}
            showMenuIconButton={false}
          /> 
        </div>

      );
  }
}    


// WEBPACK FOOTER //
// ./src/Bar.js